// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"b503ef71","87":"1663312c","134":"60c8029f","343":"8cc62c13","499":"ce8f4517","540":"aca0ddbb","568":"cba01cdd","572":"449ee79a","648":"078e3e1a","878":"53d1eea0","961":"4ce98f62"}[chunkId] + ".chunk.js";
};